export default __webpack_public_path__ + "static/media/portfolio1.916ec62e.jpg";